var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menu.length)?_c('ParentPage',{staticClass:"Manuals",attrs:{"menu":_vm.menu,"root-route-name":_vm.rootRouteName}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }